import React, { Fragment } from 'react';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer
} from 'recharts';
import { H5, H6 } from '@blueprintjs/core'

const SimpleChart = ({ data, value, domain, YName, XName, attributes }) => {

    return (
        <Fragment>
            <div className='basic-chart'>
                <H5 className='title-results' style={{ width: '8%', height: '100%', diplay: 'flex', alignItems: 'center' }}>
                    {YName}
                </H5>
                <div style={{ width: '99%', height: 500 }} >
                    <ResponsiveContainer>
                        <BarChart
                            // width={800}
                            height={300}
                            data={data}
                            padding={{ bottom: 40 }}
                            margin={{
                                top: 30, bottom: 25,
                            }}
                        >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="name" tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} />
                            <YAxis domain={domain} interval={1} tick={{ fill: 'rgba(255, 255, 255, 0.938)' }} />
                            <Tooltip />
                            {/* <Legend /> */}
                            <Bar dataKey={value} barSize={50} fill="#3563FB" />
                        </BarChart>
                    </ResponsiveContainer>
                    {!attributes &&
                        <H5 className='title-results text-center' style={{ width: '100%' }}>
                            {XName}
                        </H5>
                    }
                </div>
            </div>
            {attributes &&
                <Fragment>
                    {attributes.map((attr, i) => {
                        return (
                            <div className='basic-chart' key={i}>
                                <H6 className='title-results' style={{ width: '8%', height: '100%', diplay: 'flex', alignItems: 'center' }}>
                                    {attr.name}
                                </H6>
                                <div className="attributes-chart ">
                                    {data.map((singleData, j) => {
                                        return (
                                            <p key={`${i}-${j}`} className='text-center'>{singleData.attributes[i].quantity} {attr.unit}</p>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </Fragment>
            }

        </Fragment>
    );
}

export default SimpleChart

